import { Suspense, lazy } from "react";

const Content = lazy(() => import("./SSOLandingContent"));

export function SSOLandingPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Content />
    </Suspense>
  );
}
